module.exports = __webpack_public_path__ + "img/preview-8.0dd118fc.png";